import useAppLookup from '@/hooks/useAppLookup.js';
import useLookup from '@/hooks/useLookup.js';
import argumentDataSources from '@/schema/argumentDataSources.js';

const appLookups = [
  argumentDataSources.appActionInstance, //
  argumentDataSources.appActionCustomArguments,
  argumentDataSources.appLongPollingActionInstance,
  argumentDataSources.appActionArgumentList,
  argumentDataSources.appActionArgumentListTest,
  argumentDataSources.appActionOnCompletionHookActionInstance
];

const getLookupMethod = (dataSource, isLookup = true, dataType = 'list') => {
  if (!isLookup || dataType !== 'list') {
    return () => ({ lookup: [], loading: false, reload: () => {} });
  }
  if (dataSource === argumentDataSources.workflowStep) {
    return useLookup;
  }
  if (appLookups.includes(dataSource)) {
    return useAppLookup;
  }
  return () => ({ lookup: [], loading: false, reload: () => {} });
};

export default getLookupMethod;
